const selectors = {
  flag: '[data-badge]',
  aspectRatio: 'data-aspectratio',
};

const setBadgePosition = (images) => {
  images.forEach((image) => {
    const saleBadge = image.querySelector(selectors.flag);

    if (saleBadge === null) {
      return;
    }

    const imageAspectRatio = parseFloat(image.getAttribute(selectors.aspectRatio));
    const imageWidth = image.offsetWidth;
    const imageHeight = image.offsetHeight;
    const containerAspectRatio = imageWidth / imageHeight;
    let posTop = 0;
    let posLeft = 0;

    if (imageAspectRatio < containerAspectRatio) {
      posLeft = (imageWidth - imageHeight * imageAspectRatio) / 2;
    } else {
      posTop = (imageHeight - imageWidth / imageAspectRatio) / 2;
    }

    saleBadge.style.cssText = `top: ${posTop}px; left: ${posLeft}px`;
  });
};

export default setBadgePosition;
